/**
 * Hero Background Image Scroll Effect
 * Shows/hides hero background image when scrolling to valeurs section
 */

export function initHeroScroll() {
    const heroImage = document.getElementById('hero-bg-image');
    const valeursSection = document.querySelector('[data-valeurs]');
    const racesSection = document.querySelector('[data-races-slider]');
    
    
    // Create intersection observer
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    heroImage.classList.remove('hidden');
                    heroImage.classList.add('opacity-100');
                } 
            });
        },
        {
            threshold: 0.1, 
            rootMargin: '0px'
        }
    );
    const observer2 = new IntersectionObserver(
        (entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    heroImage.classList.add('hidden');
                    heroImage.classList.remove('opacity-100');
                } 
            });
        },
        {
            threshold: 0.1, 
            rootMargin: '0px'
        }
    );
    
    // Start observing the valeurs section
    if (!valeursSection || !racesSection) return;
    observer.observe(valeursSection);
    observer2.observe(racesSection);
}

// Initialize on DOM load
document.addEventListener('DOMContentLoaded', initHeroScroll);